<template>
  <div class="trace-log-container">
    <el-table :data="logs" height="100%">
      <el-table-column
        type="index"
        :align="align"
        width="50"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        :align="align"
        width="180"
        label="操作时间"
      ></el-table-column>
      <el-table-column
        prop="happenTime"
        :align="align"
        width="180"
        label="发生时间"
      ></el-table-column>
      <el-table-column
        prop="content"
        :align="align"
        label="轨迹信息"
      ></el-table-column>
    </el-table>
    <!-- <el-pagination layout="prev, pager, next, total
    
    " :total="1000"> </el-pagination> -->
  </div>
</template>

<script>
export default {
  props: {
    waybillSplitId: {},
    waybillNumber: {},
    waybillSplitNumber:{}
  },
  data() {
    return {
      align: "center",
      logs: [],
    };
  },
  mounted(){
    this.getData()
  },
  watch: {
    waybillSplitNumber: {
      handler(val) {
        if (!val) {
          this.baseInfo = {};
          this.goods = [];
          this.financeInInfo = {};
          this.logs = []
          return
        }
        this.getData();
      },
    },
  },
  methods: {
    async getData() {
      if(!this.waybillSplitNumber){
        return
      }
      const res = await this.$API.getTrackTransportList({
        documentNumber: this.waybillSplitNumber,
        documentStatus: "bill_tms_waybill_split_v3:document_status",
      });
      this.logs = res.data.result || [];
    },
  },
};
</script>

<style scoped lang="less">
.trace-log-container {
  height: 100%;
  display: flex;
  flex-flow: column;
}
</style>